var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2778_45987)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 2.83398C6.25114 2.83398 4.83337 4.25175 4.83337 6.00065C4.83337 7.74955 6.25114 9.16732 8.00004 9.16732C9.74894 9.16732 11.1667 7.74955 11.1667 6.00065C11.1667 4.25175 9.74894 2.83398 8.00004 2.83398ZM5.83337 6.00065C5.83337 4.80403 6.80342 3.83398 8.00004 3.83398C9.19666 3.83398 10.1667 4.80403 10.1667 6.00065C10.1667 7.19727 9.19666 8.16732 8.00004 8.16732C6.80342 8.16732 5.83337 7.19727 5.83337 6.00065Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 0.833984C4.042 0.833984 0.833374 4.04261 0.833374 8.00065C0.833374 10.033 1.67997 11.8684 3.03838 13.172C4.32559 14.4073 6.07459 15.1673 8.00004 15.1673C9.92549 15.1673 11.6745 14.4073 12.9617 13.172C14.3201 11.8684 15.1667 10.033 15.1667 8.00065C15.1667 4.04261 11.9581 0.833984 8.00004 0.833984ZM1.83337 8.00065C1.83337 4.5949 4.59428 1.83398 8.00004 1.83398C11.4058 1.83398 14.1667 4.5949 14.1667 8.00065C14.1667 9.46385 13.6576 10.8075 12.806 11.8651C12.2766 10.8558 11.2191 10.1673 10 10.1673H6.00004C4.781 10.1673 3.72346 10.8558 3.1941 11.8651C2.34252 10.8075 1.83337 9.46385 1.83337 8.00065ZM10 11.1673C10.956 11.1673 11.7681 11.7868 12.0555 12.6463C10.971 13.5939 9.55296 14.1673 8.00004 14.1673C6.44712 14.1673 5.02906 13.5939 3.94462 12.6463C4.23198 11.7868 5.04413 11.1673 6.00004 11.1673H10Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2778_45987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCircle);
export default __webpack_public_path__ + "static/media/PersonCircle.2d2c2995c32106461c2febc03e592c58.svg";
export { ForwardRef as ReactComponent };